/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementCodeBlockIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementCodeBlockIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path d="M8.5 11H6V10H8.5V11Z" fill="currentColor" />
            <path d="M12 9H8V8H12V9Z" fill="currentColor" />
            <path d="M12 7H8V6H12V7Z" fill="currentColor" />
            <path d="M8.5 5H6V4H8.5V5Z" fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13 2C13.5523 2 14 2.44772 14 3V12C14 12.5177 13.6067 12.9438 13.1025 12.9951L13 13H3L2.89746 12.9951C2.42703 12.9472 2.05278 12.573 2.00488 12.1025L2 12V3C2 2.44772 2.44772 2 3 2H13ZM3 12H13V3H3V12Z"
              fill="currentColor"
            />
          </g>
          <path opacity="0.4" d="M4.5 3L4.5 12" stroke="currentColor" />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementCodeBlockIcon.tags = [
  'code',
  'code block',
  'programming',
  'developer',
  'script',
  'syntax',
  'editor',
];

ElementCodeBlockIcon.category = 'Navigator';

ElementCodeBlockIcon.iconSize = 16;
